import * as httpApi from '@cian/http-api/browser';
import * as telemetry from '@cian/telemetry/browser';

export function setupDependencies(): void {
  telemetry.setup();
  httpApi.setup({});
}
